module.exports = __webpack_public_path__ + "img/RX-RAD-CONVENCIONAL-Moviles-6-zoom.ce092003.png";